@if(loading) {
  <div class="bg-black/50 flex justify-center items-center fixed inset-0 z-40">
    <app-loader [message]="'Buscando'"></app-loader>
  </div>
}

<div class="p-6 space-y-5">
  <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5">
    <div class="flex flex-wrap items-end gap-3">
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-1 block">Mes</label>
        <p-select [options]="months" [(ngModel)]="selectedMonth" optionLabel="text" optionValue="value"
          (onChange)="changeMonthFilter($event)" class="w-full min-w-[160px]" />
      </div>
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-1 block">Año</label>
        <p-select [options]="years" [(ngModel)]="selectedYear" optionLabel="text" optionValue="value"
          (onChange)="changeYearFilter($event)" class="w-full min-w-[120px]" />
      </div>
      <button pButton label="Buscar" icon="pi pi-search" class="p-button-sm" (click)="getBalance()"></button>
    </div>
  </div>

  @if(consumptions) {
    <app-custom-table [rowsByPage]="30" [headers]="headers" [elements]="consumptions"
      [actions]="[]" [hasButton]="false" [hasFilter]="true" [hasDownload]="true"
      [downloadOptions]="downloadOptions" (downloadAction)="download($event)"></app-custom-table>
  }
</div>
